import { useSignal } from '@preact/signals-react'
import { useCallback, useEffect } from 'react'
import { getSubmit, formatDate } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { groupedExportsDateRange } from 'Pages/Admin/GroupedExports/@signals'
import { groupingExecutionType } from '../@signals'

export default function useGroupingExportsData() {
	const data = useSignal([])
	const isLoading = useSignal(false)

	const getData = useCallback(() => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.REPORTS}/export-group-executions`, {
			startBookingDate: formatDate(groupedExportsDateRange.value[0], { format: 'yyyyMMdd' }),
			endBookingDate: formatDate(groupedExportsDateRange.value[1], { format: 'yyyyMMdd' }),
			executionType: groupingExecutionType.value,
		})
			.then(res => {
				data.value = res
				isLoading.value = false
			})
			.catch(() => {
				isLoading.value = false
			})
	}, [])


	useEffect(() => {
		getData()
	}, [ groupedExportsDateRange.value, groupingExecutionType.value ])


	return {
		data: data.value,
		isLoading: isLoading.value,
	}
}